import {configureStore} from '@reduxjs/toolkit';
import userReducer from './redux/userSlice';
import snackReducer from './redux/snackSlice';
import favReducer from './redux/favSlice';
import cartReducer from './redux/cartSlice';
import checkoutSlice from './redux/checkoutSlice';
import adminSlice from './redux/adminSlice';

export default configureStore({
  reducer: {
    user: userReducer,
    snack: snackReducer,
    fav: favReducer,
    cart: cartReducer,
    checkout: checkoutSlice,
    admin: adminSlice,
  },
  devTools: false,
});
